import { connect } from "react-redux";

import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { changeFilterType, changeFilterValue } from "../../State/EmployerDocumentsActionCreators";
import { ImportEmployerDocumentsFilter, ImportEmployerDocumentsFilterType } from "../../../EmployeeServiceTypes";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { getSelectedFilterValueByType } from "../../State/EmployerDocumentsStateUtils";

import { EmployerDocumentsFilter } from "./EmployerDocumentsFilter";

const mapStateToProps = (state: FullFormState) => {
    const selectedFilterType = state.employerDocuments?.filterType ?? ImportEmployerDocumentsFilterType.Month;

    return {
        selectedFilterType: selectedFilterType,
        selectedFilterValue:
            state.employerDocuments?.filterValue ??
            getSelectedFilterValueByType(
                selectedFilterType,
                state.employerDocuments?.options?.filter?.selectValues ??
                    ({} as ImportEmployerDocumentsFilter["selectValues"])
            ),
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onChangeFilterType: (filterType: ImportEmployerDocumentsFilterType) => dispatch(changeFilterType(filterType)),
    onChangeFilterValue: (filterValue: string | number) => dispatch(changeFilterValue(filterValue)),
});

export const EmployerDocumentsFilterContainer = connect(mapStateToProps, mapDispatchToProps)(EmployerDocumentsFilter);
